import _get from 'lodash/get';
import * as c from '../../constants/game';
import { APP_REFRESH_ACTIVITY_SUCCESS } from '../../constants/app';

export const defaultState = {
  aggregateScore: 0,
  gradesScore: 0,
  iterationsScore: 0,
  performanceScore: 0,
  canChangeLevels: false,
  canLevelUp: false,
  createdAt: null,
  isAtLastLevel: false,
  levelEntries: [],
  level: {
    level: 0,
    description: '',
    performanceBenchmarkBestMS: 0,
    performanceBenchmarkWorstMS: 0,
    performanceBenchmarkBestHS: 0,
    performanceBenchmarkWorstHS: 0,
    requiredNumIterations: 0,
    requiredAggregateScore: 0,
    requiredGradesScore: 0,
    requiredIterationsScore: 0,
  },
  history: undefined,
  ranking: {
    rank: 0,
    score: 0,

    lastLevelPercentile: 0,
    overallPercentile: 0,

    totalLastLevelCompetitors: 0,
    totalCompetitors: 0,
  },
  page: c.GAME_PAGE_INTRO,
  visible: false,
};

const game = (state = defaultState, action) => {
  switch (action.type) {
    case c.GAME_LOAD:
      return { ...state, ...action.game };
    case c.GAME_TOGGLE_MODAL:
      return { ...state, visible: !state.visible };
    case c.GAME_SET_VIEW:
      return { ...state, page: action.view, visible: true };
    case APP_REFRESH_ACTIVITY_SUCCESS:
      const game = _get(action, 'result.activity.game', undefined);
      return game ? { ...state, ...action.result.activity.game } : state;
    case c.GAME_LEVEL_UP_SUCCESS:
      if (action.result.success) {
        return {
          ...state,
          ...action.result.activity.game,
          page: c.GAME_PAGE_INFO,
        };
      }
      return state;
    case c.GAME_LOAD_HISTORY_SUCCESS:
      return { ...state, history: action.result.history };
    case c.GAME_LOAD_RANKING_SUCCESS:
      return {
        ...state,
        ranking: {
          rank: action.result.rank,
          score: action.result.score,

          lastLevelPercentile: action.result.percentile,
          overallPercentile: action.result.overallPercentile,

          totalLastLevelCompetitors: action.result.lastLevelTotal,
          totalCompetitors: action.result.total,
        },
      };
    case c.GAME_CHANGE_LEVEL_SUCCESS:
      return { ...state, ...action.result.activity.game };
    default:
      return state;
  }
};

export default game;
